import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import history from "../../history";
import * as style from "./styles.module.scss";
import { postNonverbalImmediacyTest } from "../../redux/actions/psychometricTestsActions";
import ProgressBar from "../MyTests/ProgressBar";

const NonvebalImmediacy = ({ appData, postNonverbalImmediacyTestFunc }) => {
  const name = `${appData.firstName} ${appData.lastName}`;
  const questions = [
    "I use my hands and arms to gesture while talking to people.",
    "I touch others on the shoulder or arm while talking to them.",
    "I use a monotone or dull voice while talking to people.",
    "I look over or away from others while talking to them.",
    "I move away from others when they touch me while we are talking.",
    "I have a relaxed body position when I talk to people.",
    "I frown while talking to people.",
    "I avoid eye contact while talking to people.",
    "I have a tense body position while talking to people.",
    "I sit close or stand close to people while talking with them.",
    "My voice is monotonous or dull when I talk to people.",
    "I use a variety of vocal expressions when I talk to people.",
    "I gesture when I talk to people.",
    "I am animated when I talk to people.",
    "I have a bland facial expression when I talk to people.",
    "I move closer to people when I talk to them.",
    "I look directly at people while talking to them.",
    "I am stiff when I talk to people.",
    "I have a lot of vocal variety when I talk to people.",
    "I avoid gesturing while I am talking to people.",
    "I lean toward people when I talk to them.",
    "I maintain eye contact with people when I talk to them.",
    "I try not to sit or stand close to people when I talk with them.",
    "I lean away from people when I talk to them.",
    "I smile when I talk to people.",
    "I avoid touching people when I talk to them.",
  ];
  const scale = {
    Never: 1,
    Rarely: 2,
    Occasionally: 3,
    Often: 4,
    "Very Often": 5,
  };
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswer] = useState({});
  const [chosen, setChosen] = useState("");
  const [progress, setProgress] = useState(0);
  const progressCalculation = Math.round(
    (currentQuestion / questions.length) * 100
  );
  const updateProgress = () => {
    setProgress(progressCalculation);
  };
  const nextQuestion = () => {
    const next = answers[currentQuestion + 1];
    setCurrentQuestion(currentQuestion + 1);
    setChosen(Object.keys(scale)[next - 1] || "");
    updateProgress();
  };
  const previousQuestion = () => {
    const previous = answers[currentQuestion - 1];
    setCurrentQuestion(currentQuestion - 1);
    setChosen(Object.keys(scale)[previous - 1] || "");
    updateProgress();
  };
  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({ ...answers, [questionNumber - 1]: scale[chosenAnswer] });
  };
  const handleOptionButton = (e) => {
    storeAnswer(currentQuestion + 1, e.target.value);
    if (currentQuestion !== questions.length - 1) {
      setTimeout(() => {
        nextQuestion();
      }, 800);
    }
  };
  const loadChosen = () => {
    const answerScale = answers[currentQuestion - 1];
    setChosen(Object.keys(scale)[answerScale - 1]);
  };
  const submitTest = () => {
    postNonverbalImmediacyTestFunc(answers, name);
    history.push("/profile/MyTests/results", {
      testName: "nonverbalImmediacy",
      pdfName: "Nonverbal_Immediacy_Scale_Test_Feedback_Fields.pdf",
    });
  };
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div style={{ padding: "5%" }} className="col-sm-9 col-lg-8">
        <div className={style.mainSection}>
          <h2>Nonverbal Immediacy Test</h2>
          {ProgressBar(progressCalculation)}
        </div>
        <div>
          <section className="section-body p-1">
            <p className="mb-2">Please select one answer for each question.</p>
            <article>
              <div className={style.mainContainer}>
                <h4 className={style.legendContainer}>
                  <div className={style.question}>
                    Question {currentQuestion + 1} / {questions.length}
                  </div>
                  <div>{questions[currentQuestion]}</div>
                </h4>
                <div className={style.optionsContainer}>
                  {Object.keys(scale).map((key, i) => {
                    return (
                      <label
                        key={i}
                        onClick={(event) => handleOptionButton(event)}
                        className={style.optionChoice}
                      >
                         {" "}
                        <input
                          style={{ marginRight: "5px" }}
                          checked={chosen === key}
                          type="radio"
                          id="html"
                          value={key}
                        />
                        {key}
                      </label>
                    );
                  })}
                </div>
              </div>
            </article>
            <div className={style.testButtons}>
              {questions[currentQuestion] === questions[0] ? (
                <button
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                  onClick={() => history.push("/profile/MyTests")}
                >
                  Cancel
                </button>
              ) : (
                <button
                  onClick={() => {
                    loadChosen();
                    previousQuestion();
                  }}
                  style={{ minWidth: "fit-content" }}
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                >
                  Change previous answer
                </button>
              )}
              {currentQuestion === questions.length - 1 && (
                <button
                  disabled={!chosen || chosen === ""}
                  onClick={submitTest}
                  id="btnBasicInfoEditSubmit"
                  className="btn btn-primary col-12 col-sm-3 col-lg-2 my-2"
                >
                  Finish
                </button>
              )}
            </div>
            <div className="d-flex justify-content-end">
              <Link
                to="/profile/MyTests"
                className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
              >
                My Tests
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const mapDispatchToProps = {
  postNonverbalImmediacyTestFunc: postNonverbalImmediacyTest,
};
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(NonvebalImmediacy);
